define('services/toastr-service',[
    'toastr', 'services/i18n', 'underscore',
], function(Toastr, i18n, _) {

    var defaults = {
        positionClass: "toast-top-center", // Default = toast-top-right
        newestOnTop: false, // Default = true
        showMethod: "slideDown",    // Default = fadeIn
        tapToDismiss: true,  // Default = false
        timeOut: 5000,
        hideMethod: "fadeOut",
        hideDuration: 750,
        closeButton: true
    };

    var ToastrService = {

        error: function(key) {
            Toastr.error(i18n.t(key), "", defaults);
        },

        success: function(key) {
            Toastr.success(i18n.t(key), "", defaults);
        },

        notify: function(title, body, options) {
            Toastr.info(body, title, _.extend(defaults, options));
        }

    };

    return ToastrService;
});

